angular.module('TetherApp').factory('experienceService', [
    '$http',
    function ($http) {

        let randomString = function (length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let indexExperience = function () {
            let uri = '/api/v1/experiences/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let resetParticipant = function (participantId, type, experienceId) {
            let uri = '/api/v1/experience/' +
                type + '/' +
                experienceId + '/' +
                'reset-participant/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );

            return $http.post(
                uri,
                {
                    'participant_id' : participantId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let updateExperienceParticipant = function (experienceParticipantId, data) {
            let uri = '/api/v1/experience-participant/' +
                experienceParticipantId + '/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.post(
                uri,
                {"data": data},
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };
        let getExperienceParticipantFingerprint = function (experienceParticipantEid) {
            let uri = route('experienceparticipant.entry-fraud', [
                experienceParticipantEid,
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                )
            ]);
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let reprocess = function (experienceId, data) {
            return $http.post(
                '/api/v1/experience/gift-with-purchase/' + experienceId + '/reprocess',
                data,
                { cache: false, headers: { 'Cache-Control': 'no-cache' } }
            ).then(function (response) {
                return response.data;
            });
        };

        return {
            indexExperience: indexExperience,
            resetParticipant: resetParticipant,
            updateExperienceParticipant: updateExperienceParticipant,
            getExperienceParticipantFingerprint: getExperienceParticipantFingerprint,
            reprocess: reprocess
        }

    }
]);
